function styleSelect() {
  let $select = $('.js-select');
  let $placeHolder = $select.attr('data-placeholder');
  let $dropClass = $select.attr('data-class');
  $('.js-select').select2({
    minimumResultsForSearch: -1,
    placeholder: $placeHolder,
    dropdownCssClass: $dropClass
  });
}
styleSelect();
